/* eslint-disable react/prop-types */

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumbs,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { GetCourseByUser } from '../../services/courses';

import BreadcrumbsContent from './BreadcrumbsContent';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0, 3),
  },
  boot: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    margin: theme.spacing(0, 5),
  },
  notesTitle: {
    fontSize: '35px',
    fontFamily: 'Raleway',
    fontWeight: 400,
    color: theme.palette.text.default,
    cursor: 'pointer',
  },
  courseTitle: {
    fontSize: '20px',
    fontFamily: 'Raleway',
    fontWeight: 500,
    color: theme.palette.background.info,
    cursor: 'pointer',
  },
  containerCourseTitle: {
    color: theme.palette.background.info,
    display: 'flex',
    flexDirection: 'row',
  },
  breadcrumb: {
    margin: theme.spacing(1, 0),
    color: theme.palette.background.info,
  },
  imageMessageHello: {
    width: '130px',
  },
  imageEvaluation: {
    width: '130px',
  },
}));

function Breadcrumb({ course, courseByUser }) {
  const classes = useStyles();
  const paragram = useParams();
  const optionParagram = Object.keys(paragram).length;
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      {optionParagram === 2 && (
        <Grid>
          <Box>
            <Breadcrumbs
              aria-label="breadcrumb"
              className={classes.breadcrumb}
              key={course.title}
            >
              <Box className={classes.containerCourseTitle}>
                {show ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                <Typography
                  onClick={handleShow}
                  className={classes.courseTitle}
                >
                  {`${course.name}/${paragram.course}/${paragram.lesson}`}
                </Typography>
              </Box>
            </Breadcrumbs>
            <Box className={classes.container}>
              {show && courseByUser.topicsByUser ? (
                <BreadcrumbsContent themes={courseByUser.topicsByUser} />
              ) : null}
            </Box>
          </Box>
        </Grid>
      )}
      {optionParagram === 1 && (
        <Grid>
          <Box>
            <Breadcrumbs
              aria-label="breadcrumb"
              className={classes.breadcrumb}
              key={course.title}
            >
              <Box className={classes.containerCourseTitle}>
                {show ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                <Typography
                  onClick={handleShow}
                  className={classes.courseTitle}
                >
                  {`${course.name}/${paragram.course}`}
                </Typography>
              </Box>
            </Breadcrumbs>
            <Box className={classes.container}>
              {show && courseByUser.topicsByUser ? (
                <BreadcrumbsContent themes={courseByUser.topicsByUser} />
              ) : null}
            </Box>
          </Box>
        </Grid>
      )}
      {optionParagram === 0 && (
        <Grid>
          <Box>
            <Breadcrumbs
              aria-label="breadcrumb"
              className={classes.breadcrumb}
              key={course.title}
            >
              <Box className={classes.containerCourseTitle}>
                {show ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                <Typography
                  onClick={handleShow}
                  className={classes.courseTitle}
                >
                  {course.name}
                </Typography>
              </Box>
            </Breadcrumbs>
            <Box className={classes.container}>
              {show && courseByUser.topicsByUser ? (
                <BreadcrumbsContent themes={courseByUser.topicsByUser} />
              ) : null}
            </Box>
          </Box>
        </Grid>
      )}
    </>
  );
}

function Summary({ course }) {
  const classes = useStyles();
  const [courseByUser, setCourseByUser] = useState({});
  const { sub } = useSelector((store) => store.login);

  const getCourseByUser = async () => {
    const infoCourseByUser = await GetCourseByUser(sub, course.id);
    setCourseByUser(infoCourseByUser.data[0]);
  };

  useEffect(() => {
    getCourseByUser();
  }, []);

  return (
    <Grid>
      <Grid
        className={classes.container}
        direction="row"
        justifyContent="space-between"
      >
        <Grid
          item
          xs={12}
          container
          className={classes.container}
          direction="column"
          justifyContent="space-between"
        >
          <Box className={classes.root}>
            <Box><Breadcrumb course={course} courseByUser={courseByUser} /></Box>
          </Box>
        </Grid>
        <Grid direction="row" justifyContent="space-around" />
      </Grid>
    </Grid>
  );
}

export default Summary;
